import React from 'react';
import { useSelector } from 'react-redux';
import {
  Table, TableHead, TableBody, TableRow, TableCell, makeStyles,
} from '@material-ui/core';

import { selectStatistics } from '../../store/slices/statisticsSlice';
import { VideoAnalyticsData } from '../../generated-api';

export default function VideoAnalyticsTable() {
  const { videoAnalytics } = useSelector(selectStatistics);
  const classes = useStyles();

  if (videoAnalytics == null) return null;
  const { all, ...levelsAnalytics } = videoAnalytics;
  const levels = Object.keys(levelsAnalytics).map((level) => parseInt(level));
  levels.sort((a, b) => a - b);

  return (
    <Table size="small" className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell>Video</TableCell>
          <TableCell align="right">Opens</TableCell>
          <TableCell align="right">Opens (&ge; 1 min)</TableCell>
          <TableCell align="right">Completions</TableCell>
          <TableCell align="right">Average percent watched</TableCell>
          <TableCell align="right">
            Average percent watched (excluding &lt; 1 min)
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {levels.map((level) => (
          <VideoAnalyticsRow
            title={`Level ${level}`}
            analyticsData={levelsAnalytics[level]}
          />
        ))}
        <VideoAnalyticsRow
          title="All"
          analyticsData={all}
          className={classes.allVideosRow}
        />
      </TableBody>
    </Table>
  );
}

function VideoAnalyticsRow(props: {
  title: string,
  analyticsData: VideoAnalyticsData,
  className?: string,
}) {
  const { title, analyticsData, className } = props;

  const percentFormatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 1,
  });

  return (
    <TableRow className={className}>
      <TableCell>{title}</TableCell>
      <TableCell align="right">{analyticsData.opens}</TableCell>
      <TableCell align="right">{analyticsData.opens1min}</TableCell>
      <TableCell align="right">{analyticsData.completions}</TableCell>
      <TableCell align="right">
        {percentFormatter.format(analyticsData.meanPercent)}
      </TableCell>
      <TableCell align="right">
        {percentFormatter.format(analyticsData.meanPercent1min)}
      </TableCell>
    </TableRow>
  );
}

const useStyles = makeStyles((theme) => ({
  table: {
    '& th': {
      fontWeight: 'bold',
    },
  },
  allVideosRow: {
    '& td': {
      fontWeight: 'bold',
    },
  },
}));
